
import { Theme }       from './appearence/theme';

/**
 *
 * @class ConnectionViewerConfiguration
 *
 * @brief the current configuration of the connection viewer.  When changes
 * are made, say a new file is set.  The ConfigService will publish the
 * configuration to any subscribers.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      December 2023
 *
 */
export class ConnectionViewerConfiguration {

  /** the JSON train movement file being rendered */
  public file: File|null                                          = null;

  /** the width of the canvas we render to */
  public width: number                                            = 0;

  /** the height of the canvas we render to */
  public height: number                                           = 0;

  /** the user scaling factor for the timescale */
  public scaleX: number                                           = 1.0;

  /** the user scaling factor for the distance scale */
  public scaleY: number                                           = 1.0;

  /** are we in debug mode? */
  public debugMode: boolean                                       = false;

  /** are we showing the spike lines or not? */
  public spikeLineMode: boolean                                   = true;

  /** are we in dark or light mode? */
  public darkMode: boolean                                        = true;

  /** the theme to use in dark mode */
  public darkTheme: Theme|null                                    = null;

  /** the theme to use in light mode */
  public lightTheme: Theme|null                                   = null;

  /** are we displaying the navigating bar? */
  public navMode: boolean                                         = false;

  /** are we showing the heads-up display? */
  public hudMode: boolean                                         = true;

  /** which way are we rendering the HUD, when its enabled? */
  public hudSimpleMode: boolean                                   = false;

  /** standard constructor */
  constructor(init?: Partial<ConnectionViewerConfiguration>) {

    Object.assign(this, init);
  }
}
